import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '@shared/services/api.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {

  wasSuccessful: boolean = false;
  isLoading: boolean = false;
  wasSubmitted: boolean = false;
  v2Token: string;
  tableId: string;
  fileToUpload: File = null;
  clippings: string | ArrayBuffer;

  constructor( private router: Router, private route: ActivatedRoute, private api: ApiService) { }

  ngOnInit() {
    // this.route.queryParams.subscribe((params) => {
    //   if ('session_id' in params) {
    //     const session_id = params['session_id'];
    //     this.api.checkSuccessfulPurchase(session_id).subscribe((data) => {
    //       const created = data['response'];
    //       const now = Math.round(+new Date()/1000);
    //       const FIVE_MINUTES = 5 * 60;
    //       if ((now - created) < FIVE_MINUTES) {
    //         this.wasSuccessful = true
    //       } else {
    //         this.router.navigate(['/home'], { relativeTo: this.route });
    //       }
    //     });
    //   } else {
    //     this.router.navigate(['/home'], { relativeTo: this.route });
    //   }
    // });
  }

  handleFileInput(files: FileList) {
    let reader = new FileReader();
    reader.onload = () => {
      this.clippings = reader.result;
    }
    this.fileToUpload = files.item(0);
    reader.readAsText(this.fileToUpload); 
  }

  importNotes(): Promise<void> {
    this.isLoading = true;
    this.wasSubmitted = true;
    return new Promise(resolve => {
      this.api.importNotes(this.v2Token, this.tableId, this.clippings.toString()).subscribe ((response) => {
        this.isLoading = false;
        resolve();
      });
    });
  }
}
